import { useState } from "react";
import { useUser } from "../../context/userContext";
import { updateUserPassword } from "../../api/userApi";
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export function UpdatePasswordForm() {
    const { user } = useUser();
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");

    const confirmMismatch = confirmNewPassword.length > 0 && confirmNewPassword !== newPassword;

    const updatePassword = async () => {
        setSuccessMsg("");
        setErrorMsg("");

        if (newPassword !== confirmNewPassword) {
            setErrorMsg("New passwords do not match.");
            return;
        }

        try {
            const response = await updateUserPassword(user.userId, currentPassword, newPassword);

            if (response.status === 200) {
                setSuccessMsg("Password updated successfully.");
                setCurrentPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
            }
            else {
                setErrorMsg("Failed to update password. Please check your current password.");
            }
        }
        catch (error) {
            console.error("Error updating password:", error);
            setErrorMsg("An error occurred while updating the password. Please try again.");
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        updatePassword();
    }

    return (
        <div className="update-password-form-container">
            <form className="update-password-form" onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <Typography variant="h6">Update Password</Typography>

                    {successMsg && <Alert severity="success" sx={{ mb: 2 }}>{successMsg}</Alert>}
                    {errorMsg && <Alert severity="error" sx={{ mb: 2 }}>{errorMsg}</Alert>}

                    <TextField
                        fullWidth
                        label="Current Password"
                        type="password"
                        size="small"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="New Password"
                        type="password"
                        size="small"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="Confirm New Password"
                        type="password"
                        size="small"
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        error={confirmMismatch}
                        helperText={confirmMismatch ? "Passwords do not match." : ""}
                    />

                    <Stack direction="row" justifyContent="flex-end">
                        <Button type="submit" variant="contained">Update Password</Button>
                    </Stack>
                </Stack>
            </form>
        </div>
    );
}
